import React, {useRef, useState} from 'react';
import {Await, useNavigate, useSearchParams} from "react-router-dom";
import {
  ActionSheet,
  Avatar,
  Button, Dialog,
  Form, ImageUploader, ImageUploadItem,
  ImageViewer,
  Input,
  NavBar,
  Result,
  SearchBar,
  Selector,
  Steps, Toast
} from "antd-mobile";
// @ts-ignore
import {ComboGrid,GridColumn} from 'rc-easyui';
import 'rc-easyui/dist/themes/default/easyui.css';
import 'rc-easyui/dist/themes/icon.css';
import 'rc-easyui/dist/themes/react.css';

import axios from "axios";
import {paramsToFormData} from "../../utils/paramsToFormData";
import {LoadingContext} from "../../components/Loading/LoadingContext";
import Qrcode from "../../components/Qrcode";
import {Html5Qrcode} from "html5-qrcode";
import { Step } from 'antd-mobile/es/components/steps/step';
import ApiService from "../../utils/ApiService";
import styles from './index.module.css';
import {getExtension, getObjectURL} from "../../utils/StringHelper";

function DeviceBind(props:any) {
  const navigate = useNavigate()
  const [search,setSearch] = useSearchParams()
  const id = search.get('id')
  const [avatarView, setAvatarView] = useState(false)
  const defaultTempObj = {longPressTimer:0,qrActive:false,step:0,keyword:'',peopleList:[],bindState: '请先输入设备编号',peopleInfo:{}};
  const tempObj = React.useRef<any>(defaultTempObj);
  const { setIsLoading } = React.useContext(LoadingContext);
  const [_,upPage]=React.useState(Math.random());
  const {current: formObj} = React.useRef<any>({id:'',device_type:'生命体征',device_id:'',name:'',address:'',people_id:''});

  React.useEffect(()=>{

  },[])

  const getInfo = async () => {
    setIsLoading(true);
    const ret = await ApiService.getPeopleInfo(formObj.people_id);
    setIsLoading(false);
    if (ret && ret.code == 1) {
      tempObj.current.peopleInfo = ret.data;
    } else if (ret) {
      Toast.show(ret.message)

    }
  }

  //获取设备列表
  const searchPeople = async () =>{
    //在搜索之前设置,搜索的开始，结束第一次展示
    setIsLoading(true);

    const ret = await ApiService.getPeopleList({keyword:tempObj.current.keyword,rows:100});
    setIsLoading(false);

    if(ret && ret.code==1){
      tempObj.current.peopleList = ret.rows;
      upPage(Math.random());
    }else if(ret){
      Toast.show("搜索人员失败"+ret.message)
    }
  }

  const checkBind =async () => {
    setIsLoading(true);

    if(!formObj.device_id) tempObj.current.bindState = '请先输入设备编号';
    const ret = await ApiService.getBindStatus(formObj.device_id);
    setIsLoading(false);

    if (ret && ret.code == 1) {
      if(ret.data.unused){
        tempObj.current.bindState = (<span style={{color:"green"}}>未绑定</span>);
      }else{
        tempObj.current.bindState = (<span style={{color:"red"}}>已绑定({ret.data.people.name})</span>);
      }
      //设备已经存在
      tempObj.current.deviceInfo = ret.data.info;
      formObj.id = ret.data.info.id;

      //设备已经存在安装照片
      if(ret.data.info?.install_files){
        setFileList(ret.data.info.install_files)
      }else{//不存在，使用更新图片
        upPage(Math.random());
      }
    } else if (ret) {
      Toast.show("获取绑定状态:" + ret.message)
    }
  }


  const saveBind = async ()=>{
    setIsLoading(true);
    const ret = await ApiService.setBindInfo(formObj);
    setIsLoading(false);
    if (ret && ret.code == 1) {
      tempObj.current.step=2
      upPage(Math.random())
    } else if (ret) {
      Toast.show(ret.message)
    }
  }

  const [fileList, setFileList] = useState<ImageUploadItem[]>([])

  const fileUpload = async (file: any) => {

    const data ={
      file,
      suffix: getExtension(file.name),
      father_id: tempObj.current.deviceInfo.id,
      father_type: 'device',
      f_type: 'install',
      createby: window.localStorage.getItem('userid')||'',
      overlap: '0',
      number: '0',
    };

    const ret = await ApiService.fileUpload(data);
    if (ret && ret.code == 1) {
      return {
        id:ret.data.id,
        f_type:ret.data.f_type,
        path:ret.data.path,
        url: getObjectURL(file),
      }
    } else if (ret) {
      Toast.show(ret.message)
    }

    return {
      url: require('../../static/img/upload_err.png'),
    }
  }

  const deleteFiles=async (item: any) => {
    const result = await Dialog.confirm({
      content: '是否确认删除',
      onConfirm: () => {
      },
    })
    if(!result) return result;

    setIsLoading(true);
    const ret = await ApiService.deleteFile(item);
    setIsLoading(false);
    if (ret && ret.code == 1) {
      Toast.show("删除成功");
      return true;
    } else if (ret) {
      Toast.show(ret.message)
    }
    return false;
  }


  return (
    <div>
      <NavBar onBack={()=>navigate('/home')}>设备绑定</NavBar>
      <Steps current={tempObj.current.step}>
        <Step title='填写信息' />
        <Step title='信息确认'/>
        <Step title='绑定成功'/>
      </Steps>
      {tempObj.current.step==0?
        <>
          <Form layout='horizontal' mode='card' style={{'--prefix-width':'5.5em'}}>
            <Form.Header>设备绑定</Form.Header>
            <Form.Item label='设备类型'>

              <Selector
                options={[{label: '生命体征',value: '生命体征'},]}
                defaultValue={[formObj.device_type]}
                onChange={(arr, extend) => {
                  formObj.device_type = arr[0];
                  upPage(Math.random())
                }}
              />
            </Form.Item>
            <Form.Item label='设备编号' extra={<a onClick={()=>{ tempObj.current.qrActive = true;upPage(Math.random())}}>扫描</a>}>
              <Input placeholder='请输入' value = {formObj.device_id}
                     onChange={(val)=>{
                       formObj.device_id = val;
                       upPage(Math.random())
                     }}
                     onBlur={()=>checkBind()}
              />

            </Form.Item>
            <div style={{marginLeft:25,fontSize:13,color:'#b7b7b7',marginBottom:5}}>绑定检测：{tempObj.current.bindState}</div>
            <Form.Item label='设备名称' name = "name">
              <Input placeholder='设备名称' value = {formObj.name} onChange={(val)=>{formObj.name = val;upPage(Math.random()) }}/>
            </Form.Item>
            <Form.Item label='安装地址' name = "address">
              <Input placeholder='安装地址' value = {formObj.address} onChange={(val)=>{formObj.address = val;upPage(Math.random()) }}/>
            </Form.Item>
            <Form.Item label='搜索人员' extra={<a onClick={searchPeople}>搜索</a>}>
              <Input placeholder='输入姓名、地址、或电话' value = {tempObj.current.keyword} onChange={(val)=>{tempObj.current.keyword = val;upPage(Math.random()) }}/>
            </Form.Item>
            <Form.Item label='绑定人员'>
              <ComboGrid
                panelStyle={{ width: '100%' }}
                valueField="id"
                textField="name"
                data={tempObj.current.peopleList}
                value={formObj.people_id}
                onChange={(value:any) => {
                  formObj.people_id = value;
                }}
              >
                <GridColumn field="name" width="20%" title="姓名"></GridColumn>
                <GridColumn field="idcard" width="40%" title="身份证号"></GridColumn>
                <GridColumn field="address" width="40%" title="地址"></GridColumn>
              </ComboGrid>
            </Form.Item>

            <div style={{textAlign:'center',marginTop:50}}>
              <Button  color='primary' onClick={async () => {
                if(!formObj.device_id) {
                  Toast.show("请输入设备编号");
                  return
                }
                if(!formObj.id) {
                  Toast.show("检测绑定状态失败，请重新输入设备编号");
                  return
                }
                if(!formObj.people_id) {
                  Toast.show("请选择要绑定的人员");
                  return
                }
                if(!formObj.name) {
                  Toast.show("请输入设备名称");
                  return
                }
                if(!formObj.address) {
                  Toast.show("请输入安装地址");
                  return
                }
                await getInfo();
                tempObj.current.step = 1
                upPage(Math.random())
              }}>下一步</Button>
            </div>
          </Form>
          <Qrcode active={tempObj.current.qrActive}
                  onCode={(value:any)=>{
                    formObj.device_id = value
                    checkBind();
                  }}
                  onClose={()=>{
                    tempObj.current.qrActive = false
                    upPage(Math.random());
                  }}
          ></Qrcode>
        </>
      :tempObj.current.step==1?
          <>
            <div style={{fontSize:'15px',lineHeight:'30px',margin:20}}>
              <img src={tempObj.current.peopleInfo.avatar?.url} style={{ width: '80px',height: '80px',borderRadius:'10px',float:'right' }}
                   onClick={()=>setAvatarView(true)}
              />
              <ImageViewer
                image={tempObj.current.peopleInfo.avatar?.url}
                visible={avatarView}
                onClose={() => {
                  setAvatarView(false)
                }}
              />
              <span style={{width:'80px',color:'#cccccc',display:'inline-block'}}>设备类型</span>{formObj.device_type}
              <br/>
              <span style={{width:'80px',color:'#cccccc',display:'inline-block'}}>设备编码</span>{formObj.device_id}
              <br/>
              <span style={{width:'80px',color:'#cccccc',display:'inline-block'}}>设备名称</span>{formObj.name}
              <br/>
              <span style={{width:'80px',color:'#cccccc',display:'inline-block'}}>安装地址</span>{formObj.address}
              <br/>
              <span style={{width:'80px',color:'#cccccc',display:'inline-block'}}>人员姓名</span>{tempObj.current.peopleInfo.name}
              <br/>
              <span style={{width:'80px',color:'#cccccc',display:'inline-block'}}>身份证号</span>{tempObj.current.peopleInfo.idcard}
              <br/>
              <span style={{width:'80px',color:'#cccccc',display:'inline-block'}}>地址</span>{tempObj.current.peopleInfo.address}
              <br/>
              <span style={{width:'80px',color:'#cccccc',display:'inline-block'}}>采集状态</span>{tempObj.current.peopleInfo.collect_time?'已采集':'未采集'}
              <br/>
              <Form.Item label='安装照片'>
                <ImageUploader
                  value={fileList}
                  onChange={setFileList}
                  upload={fileUpload as any}
                  onDelete={async (info) => {
                    console.log('info',info)
                    return deleteFiles(info);
                  }}
                />
              </Form.Item>
            </div>

            <div style={{textAlign:'center'}}>
            <Button  color='primary' onClick={()=>{
              tempObj.current.step=0
              upPage(Math.random())
            }}>上一步</Button>

            <Button  color='primary' onClick={()=>{saveBind()}} style={{marginLeft:10}}>确认绑定</Button>

            </div>
          </>
      :<>
            <Result
              status='success'
              title='绑定成功'
              description='设备绑定成功'
            />
            <div style={{textAlign:'center'}}>
              <Button  color='primary' onClick={()=>{
                navigate(-1)
              }}>返回</Button>
              <Button  color='primary' onClick={()=>{
                tempObj.current.step=0
                formObj.id='';
                formObj.device_type='生命体征';
                formObj.device_id='';
                formObj.name='';
                formObj.address='';
                formObj.people_id='';
                tempObj.current = defaultTempObj;
                upPage(Math.random())
              }} style={{marginLeft:10}}>再绑一个</Button>
            </div>
       </>
      }

      </div>
  );
}

export default DeviceBind;
